import { Box } from '@superdispatch/ui-lab';
import { PermissionView } from '../permission/core/PermissionView';
import { LoadOffersDrawerContent } from './LoadOffersDrawer';

export function LoadOffersPageMobile() {
  return (
    <Box paddingBottom="xxlarge" backgroundColor="White">
      <PermissionView name="marketplace" permission="can_view">
        <LoadOffersDrawerContent />
      </PermissionView>
    </Box>
  );
}
